<template>
  <div id="hotelType">
    <!-- 弹窗 -->
    <el-dialog
      v-model="dialogVisible"
      :title="`${form.id ? '编辑' : '添加'}门店类型`"
      :width="$store.state.screenWidth > 1200 ? '450px' : '98%'"
      align-center
      @closed="dialogClosed"
      :close-on-click-modal="false"
    >
      <el-form :model="form" ref="formRef" :rules="rules">
        <el-form-item label="类型名称" label-width="100px" prop="name">
          <el-input
            v-model="form.name"
            placeholder="请输入类型名称"
            clearable
          />
        </el-form-item>
        <el-form-item label="状态" label-width="100px" prop="state">
          <el-switch
            v-model="form.state"
            :active-value="1"
            :inactive-value="0"
          />
        </el-form-item>
        <el-form-item
          label="备注"
          show-overflow-tooltip
          label-width="100px"
          prop="remark"
        >
          <el-input
            v-model="form.remark"
            :autosize="{ minRows: 2, maxRows: 4 }"
            type="textarea"
            maxlength="30"
            show-word-limit
            placeholder="请输入备注"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="addhotelType(formRef)"
            >确定</el-button
          >
        </span>
      </template>
    </el-dialog>
    <!-- 头部 -->
    <div class="head">
      <div class="head_left">
        <el-button
          v-grantShow="$store.state.SysGrant.AddHotel"
          type="primary"
          icon="Plus"
          @click="dialogVisible = true"
          >添加类型</el-button
        >
        <el-button
          v-grantShow="$store.state.SysGrant.DelHotel"
          type="danger"
          icon="Delete"
          @click="hotelTypeDel(checkedData, 'all')"
          >删除类型</el-button
        >
      </div>
      <div class="head_right">
        <el-input
          v-model="hotelType_req.value"
          placeholder="请输入关键词"
          class="input-with-select"
          :clearable="true"
        >
          <template #append>
            <el-button icon="Search" @click="hotelTypeGet" />
          </template>
          <template #prepend>
            <el-select
              v-model="selectId"
              placeholder="Select"
              style="width: 100px"
            >
              <el-option
                v-for="(item, index) in selectData"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
        </el-input>
      </div>
    </div>
    <!-- 表格 -->
    <el-table
      ref="multipleTable"
      :data="hotelTypeData"
      tooltip-effect="dark"
      style="width: 100%"
      :header-cell-style="{ backgroundColor: '#F4F7FB' }"
      :header-row-style="{
        backgroundColor: '#F4F7FB',
        color: '#1E2026',
      }"
      @selection-change="
        (value) => {
          checkedData = value.map((item) => item.id);
        }
      "
    >
      <el-table-column
        type="selection"
        :width="$store.state.screenWidth > 1200 ? 55 : 30"
      />
      <el-table-column prop="name" label="类型名称" min-width="120">
      </el-table-column>
      <el-table-column label="备注" min-width="150">
        <template #default="scope">
          {{ scope.row.remark || "--" }}
        </template>
      </el-table-column>
      <el-table-column label="添加时间" min-width="165">
        <template #default="scope">
          <template v-if="scope.row.addtime">
            {{
              $moment(scope.row.addtime * 1000).format("yyyy-MM-DD HH:mm:ss")
            }}
          </template>
          <template v-else> -- </template>
        </template>
      </el-table-column>
      <el-table-column label="状态" min-width="80">
        <template #default="scope">
          <el-switch
            v-model="scope.row.state"
            :active-value="1"
            :inactive-value="0"
            @change="stateChange(scope.row)"
            :disabled="
              !$dataConver.checkGrants(
                $store.state.userInfo.grants,
                $store.state.SysGrant.AddHotel
              )
            "
          />
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="120"
        :fixed="$store.state.screenWidth > 1200 ? 'right' : false"
      >
        <template #default="scope">
          <el-button
            v-grantShow="$store.state.SysGrant.AddHotel"
            link
            type="primary"
            @click="hotelTypeEditor(scope.row)"
            >编辑</el-button
          >
          <el-divider
            v-grantShow="$store.state.SysGrant.DelHotel"
            direction="vertical"
          ></el-divider>
          <el-button
            v-grantShow="$store.state.SysGrant.DelHotel"
            link
            type="primary"
            @click="hotelTypeDel(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 页码 -->
    <el-pagination
      background
      :pager-count="$store.state.screenWidth > 1200 ? 7 : 5"
      :page-sizes="[10, 20, 100, 200, 500, 1000]"
      layout="prev,pager,next,sizes,slot"
      v-model:current-page="hotelType_req.page"
      v-model:page-size="hotelType_req.page_max"
      :total="tableCount"
    >
      <div class="statistical">
        每页<b style="color: #ff0000">{{ hotelType_req.page_max }}</b
        >条/共<b style="color: #059669">{{ tableCount }}</b> 条数据
      </div>
    </el-pagination>
  </div>
</template>

<script setup>
import { reactive, ref, getCurrentInstance, onMounted, watch } from "vue";
import { useStore } from "vuex";
import { ElMessage, ElMessageBox } from "element-plus";
//获取公共方法
let { proxy } = getCurrentInstance();
//全局数据
let vuex = useStore();
//门店类型请求参数
let hotelType_req = reactive({
  value: "",
  page: 1,
  page_max: 10,
});
//表单对象
let formRef = ref(null);
//门店类型表单数据
let form = reactive({
  name: "",
  remark: "",
  state: 1,
});
//校验规则
let rules = reactive({
  name: [{ required: true, message: "门店类型名称不能为空", trigger: "blur" }],
  state: [{ required: true, message: "请选择状态", trigger: "blur" }],
});
//搜索类型
let selectData = {
  1: {
    label: "类型名称",
    value: 1,
    key: "name",
  },
  2: {
    label: "备注",
    value: 2,
    key: "remark",
  },
};
//搜索id
let selectId = ref(1);
//多选数据
let checkedData = ref([]);
//门店类型数据
let hotelTypeData = ref([]);
//门店类型总数
let tableCount = ref(0);
//编辑/添加门店类型弹窗状态
let dialogVisible = ref(false);
//监听请求参数变化事件
watch(
  [() => hotelType_req.value, () => hotelType_req.page_max, selectId],
  async (newValue, oldValue) => {
    if (hotelType_req.page == 1) {
      hotelTypeGet();
    } else {
      hotelType_req.page = 1;
    }
  }
);
watch([() => hotelType_req.page], async (newValue, oldValue) => {
  hotelTypeGet();
});
//页面渲染事件
onMounted(() => {
  hotelTypeGet();
});
//门店类型获取
function hotelTypeGet() {
  let req = {
    page: hotelType_req.page,
    page_max: hotelType_req.page_max,
  };
  req[selectData[selectId.value].key] = hotelType_req.value;
  proxy.$http
    .get("webapi/hotel_type_mgr?item=list", {
      params: {
        ...req,
      },
    })
    .then(({ data: res }) => {
      if (res.code == 0) {
        tableCount.value = res.data.count;
        hotelTypeData.value = res.data.list;
      }
    })
    .catch((err) => {
      console.log("请求失败");
    });
}
//添加门店类型
function addhotelType(formEl) {
  if (!formEl) return apiSend();
  formEl.validate((valid) => {
    if (valid) {
      apiSend();
    }
  });
}
//请求发送
function apiSend() {
  proxy.$http
    .post(`webapi/hotel_type_mgr?item=${form.id ? "set" : "add"}`, {
      ...form,
    })
    .then(({ data: res }) => {
      if (res.code == 0) {
        ElMessage({
          message: `${form.id ? "编辑" : "添加"}成功！`,
          type: "success",
        });
        dialogVisible.value = false;
        hotelTypeGet();
      } else {
        ElMessage({
          message: `${form.id ? "编辑" : "添加"}失败！`,
          type: "error",
        });
      }
    })
    .catch((err) => {
      console.log("请求失败");
    });
}
//表格内状态变换事件
function stateChange(obj) {
  hotelTypeEditor(obj, false);
  addhotelType();
}
//编辑门店类型
function hotelTypeEditor(obj, show = true) {
  form.id = obj.id;
  form.name = obj.name;
  form.remark = obj.remark;
  form.state = obj.state;
  dialogVisible.value = show;
}
//删除门店类型
function hotelTypeDel(id, type) {
  if (type == "all") {
    id = id.join(",");
    if (!id)
      return ElMessage({
        message: `请选择门店类型`,
        type: "warning",
      });
  }
  ElMessageBox.confirm(
    `此操作将永久删除${type == "all" ? "选中" : "该"}类型, 是否继续?`,
    "提示",
    {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }
  )
    .then(() => {
      proxy.$http
        .post(`webapi/hotel_type_mgr?item=del`, { id })
        .then(({ data: res }) => {
          if (res.code == 0) {
            ElMessage({
              message: `删除成功！`,
              type: "success",
            });
            dialogVisible.value = false;
            hotelTypeGet();
          } else {
            ElMessage({
              message: `删除失败！`,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.log("请求失败");
        });
    })
    .catch(() => {
      console.log("取消");
    });
}
//弹窗关闭事件
function dialogClosed() {
  formRef.value.resetFields();
  form.id = undefined;
  form.name = "";
  form.remark = "";
  form.state = 1;
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/hotel/hotelType.scss";
</style>